<template>
    <SidebarMenu class="rounded hover:bg-cinder-800">
        <SidebarMenuItem>
            <DropdownMenu>
                <DropdownMenuTrigger as-child>
                    <SidebarMenuButton
                        size="lg"
                        class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground pl-3"
                    >
                        <Avatar
                            v-if="self.operator"
                            class="h-4 w-4 shrink-0 bg-slate-600 text-slate-200"
                            :size="32"
                            :username="self.operator.first_name"
                        />
                        <div class="grid flex-1 text-left text-sm leading-tight">
                            <span class="truncate font-semibold">{{ self.operator.first_name }}</span>
                            <span class="truncate text-xs">{{ self.operator.email }}</span>
                        </div>
                        <ChevronsUpDown class="ml-auto size-4" />
                    </SidebarMenuButton>
                </DropdownMenuTrigger>

                <DropdownMenuContent
                    class="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg border-[#27272a] bg-cinder-900 text-white"
                    :side="isSmallScreen ? 'top' : 'right'"
                    align="end"
                    :side-offset="4"
                >
                    <DropdownMenuLabel class="p-0 font-normal">
                        <div class="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                            <Avatar
                                v-if="self.operator"
                                class="h-4 w-4 shrink-0 bg-slate-600 text-slate-200"
                                :size="32"
                                :username="self.operator.first_name"
                            />
                            <div class="grid flex-1 text-left text-sm leading-tight">
                                <span class="truncate font-semibold">{{ self.operator.first_name }}</span>
                                <span class="truncate text-xs">{{ self.operator.email }}</span>
                            </div>
                        </div>
                    </DropdownMenuLabel>
                    <DropdownMenuItem variant="unstyled">
                        <div class="mt-1 flex flex-col gap-1">
                            <div
                                v-if="isSfStaffDefinitive === true"
                                class="mt-1 whitespace-nowrap"
                                @click.stop="$store.commit('self:toggleDevMode')"
                            >
                                <span
                                    v-if="isDevModeEnabled"
                                    class="cursor-pointer rounded-md bg-amber-100 px-3 py-1 text-xs text-amber-600 hover:bg-amber-200"
                                >
                                    Dev Mode Enabled
                                </span>
                                <span
                                    v-else
                                    class="cursor-pointer rounded-md bg-indigo-100 px-3 py-1 text-xs text-indigo-600 hover:bg-indigo-200"
                                >
                                    Dev Mode Disabled
                                </span>
                            </div>

                            <div
                                v-if="isSfStaffDefinitive === true"
                                class="mt-1 whitespace-nowrap"
                                @click.stop="$store.commit('self:toggleStaffMode')"
                            >
                                <span
                                    v-if="!isSfStaffDisabled"
                                    class="cursor-pointer rounded rounded-md bg-amber-100 px-3 py-1 text-xs text-amber-600 hover:bg-amber-200"
                                >
                                    Staff Mode Enabled
                                </span>
                                <span
                                    v-else
                                    class="cursor-pointer rounded rounded-md bg-indigo-100 px-3 py-1 text-xs text-indigo-600 hover:bg-indigo-200"
                                >
                                    Staff Mode Disabled
                                </span>
                            </div>
                        </div>
                    </DropdownMenuItem>

                    <DropdownMenuSeparator class="bg-[#27272a]" />

                    <DropdownMenuGroup>
                        <router-link
                            class="flex items-center rounded-md hover:bg-cinder-800"
                            :to="{
                                name: 'admin-organizations',
                            }"
                            @click="dropdownOpen = false"
                        >
                            <DropdownMenuItem v-if="isSfStaffDefinitive" variant="unstyled" class="cursor-pointer">
                                <ShieldCheck class="mr-2 h-4 w-4 text-slate-400" />
                                <span>Admin</span>
                            </DropdownMenuItem>
                        </router-link>
                        <router-link
                            class="flex items-center rounded-md hover:bg-cinder-800"
                            :to="{
                                name: 'organization-users',
                                params: { organization_id: selfActiveOrganization?.id },
                            }"
                            @click="dropdownOpen = false"
                        >
                            <DropdownMenuItem v-if="selfActiveOrganization" variant="unstyled" class="cursor-pointer">
                                <Building class="mr-2 h-4 w-4 text-slate-400" />
                                <span>Your Organization</span>
                            </DropdownMenuItem>
                        </router-link>

                        <DropdownMenuItem
                            v-if="selfActiveOrganization"
                            variant="unstyled"
                            class=" hover:bg-cinder-800 cursor-pointer"
                            @click="OnTalkToSales()"
                        >
                            <Headphones class="mr-2 h-4 w-4 text-slate-400" />
                            <span >Talk To Sales</span>
                        </DropdownMenuItem>

                        <DropdownMenuItem
                            v-if="selfActiveOrganization"
                            variant="unstyled"
                            class=" hover:bg-cinder-800 cursor-pointer"
                            @click="OnTalkToSupport()"
                        >
                            <MessageCircleQuestion class="mr-2 h-4 w-4 text-slate-400" />
                            <span >Talk To Support</span>
                        </DropdownMenuItem>

                        <router-link
                            class="flex items-center rounded-md hover:bg-cinder-800"
                            :to="{ name: 'login' }"
                            @click="dropdownOpen = false"
                        >
                            <DropdownMenuItem variant="unstyled" class="cursor-pointer">
                                <LogOut class="mr-2 h-4 w-4 text-slate-400" />
                                <span>Sign Out</span>
                            </DropdownMenuItem>
                        </router-link>
                    </DropdownMenuGroup>
                </DropdownMenuContent>
            </DropdownMenu>
        </SidebarMenuItem>
    </SidebarMenu>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import Avatar from '@/components/Avatar.vue'
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuContent,
} from '@/components/ui/dropdown-menu'
import { SidebarMenu, SidebarMenuItem, SidebarMenuButton } from '@/components/ui/sidebar'
import { LogOut, ShieldCheck, Building, ChevronsUpDown, Headphones, MessageCircleQuestion } from 'lucide-vue-next'
import { BREAKPOINTS } from '@/constants'

// Props
defineProps({
    align: {
        type: String,
        default: 'right',
    },
    sidebarOpen: Boolean,
})

const store = useStore()
const self = computed(() => store.getters.self)
const selfActiveOrganization = computed(() => store.getters.selfActiveOrganization)
const isSfStaffDefinitive = computed(() => store.getters.isSfStaffDefinitive)
const isDevModeEnabled = computed(() => store.getters.isDevModeEnabled)
const isSfStaffDisabled = computed(() => store.getters.isSfStaffDisabled)
const { appContext } = getCurrentInstance()

const dropdownOpen = ref(false)
const trigger = ref(null)
const dropdown = ref(null)

const clickHandler = ({ target }) => {
    if (!dropdownOpen.value || dropdown.value?.contains(target) || trigger.value?.contains(target)) return
    dropdownOpen.value = false
}

const keyHandler = ({ keyCode }) => {
    if (!dropdownOpen.value || keyCode !== 27) return
    dropdownOpen.value = false
}

const isSmallScreen = ref(window.innerWidth < BREAKPOINTS.md)

const onResize = () => {
    isSmallScreen.value = window.innerWidth < BREAKPOINTS.md
}

const OnTalkToSales = () => {
    window.open(
        'https://calendly.com/d/cqzs-9m2-9hn/build-your-custom-plan',
        '_blank',
        'noopener,noreferrer'
    )
}

const OnTalkToSupport = () => {
    appContext.config.globalProperties.intercomModule.show()
}

onMounted(() => {
    document.addEventListener('click', clickHandler)
    document.addEventListener('keydown', keyHandler)
    window.addEventListener('resize', onResize)
})

onUnmounted(() => {
    document.removeEventListener('click', clickHandler)
    document.removeEventListener('keydown', keyHandler)
    window.removeEventListener('resize', onResize)
})
</script>
